export const UluHandiList = [
  {
    name: "Ba' ",
    img_src: "https://66.media.tumblr.com/c268285f8146bbf01d3c086c4d446edc/b85f0e3cc7c14366-2b/s540x810/7894627112ea7726ed4c87b4e56bbcb135a4b699.png",
    description: "Ba’ is used to carry baby. It is woven from rattan, bamboo, bark and bead. It is believed to prevent the evil spirit from disturbing the baby. Generally, women will use it during gardening, mailing, homework and while in paddy fields.", 
    alt: "ba"
  },
]; 

export const UluAgriList = [
  {
      name: "Lingkuk",
      img_src:" https://66.media.tumblr.com/20afc18fb8edf1f6af879da3cac46e87/b85f0e3cc7c14366-0a/s540x810/54e18a97294328f85ba780c973dc43a9dd3a478b.png",
      description:"Lingkuk is made by iron material its handle is of wood. It is one of the equipments that used in agriculture to cut grass.", 
      alt: "lingkuk"
  }, 

  { 
      name: "Alu & Lesong",
      img_src: " https://66.media.tumblr.com/817def3ab0fec6cd8b8307f82903dd79/b85f0e3cc7c14366-41/s540x810/025769ad78377c7913762b4a3867d986e1da4bb6.png",
      description: "The alu is made of hardwood to punch the paddy in a Lesong. The Lesong made from Belian wood which helps it to stand through the test of time. It is very heavy.", 
      alt: "alu-lesong"
  },

  {
      name: "Kapak",
      img_src: "https://66.media.tumblr.com/8e12ee7d707b4d831cf7e776cb887e8f/b85f0e3cc7c14366-1a/s540x810/e0efaac40846905bab6b00fed8a339af0617b9d3.png",
      description: "Kapak or an axe is used by the people to cut off trees, firewoods, and as a weapon for hunting. It is made of iron", 
      alt: "kapak"
  },

  {
      name: "Cangkul", 
      img_src: " https://66.media.tumblr.com/9834ed4222d206a185f9cd75e2097987/b85f0e3cc7c14366-52/s540x810/84cbbcbc9c3a472d9896e84a8854a1f139cd32b2.png",
      description: "Cangkul is an agricultural tool used to hoe the soil. The blade or tip of the cangkul is made out of iron whereas the handle is made out of Belian wood.",
      alt: "cangkul "
  }, 

 
];

export const UluMusicList = [
  {
      name: "Gendang Panjang", 
      img_src: " https://66.media.tumblr.com/7c423c34b657fb255a507c58c263e9ac/b85f0e3cc7c14366-ca/s540x810/1df373cfb19ce59fa846321478e9f017d0b33438.png",
      description: "This long drum was used by the community to give a warning to the villagers about something. Not only that, it is also a traditional tool of the ulu community. The drum is very large and it long is 1.5 meters. Its body is made of hard wood while its surface cover is from animal skins.",
      alt: "gendang-panjang" 
  },
  
  {
      name: "Pagang", 
      img_src: "https://66.media.tumblr.com/2b12b39ae1c327413604af610073a3e6/8111c81f72459d11-15/s540x810/3ce2a36f4f4c6243c1df1d545d1bb2f09d8a754b.png",
      description: "Pagang or a tube zither is constructed from the length of a bamboo tube with its natural bamboo nodes closed at both ends. The strings are finely cut strips from the bamboo tube surface itself, which at either end are still connected to the cable.",
      alt: "pagang"
  }, 

  {
      name: "Sape", 
      img_src: "https://66.media.tumblr.com/933fdfa739954b3eca4304312ecdce66/8111c81f72459d11-02/s540x810/1ef66fb74fd70c51db039a6b2c146911e424956c.png",
      description:"The sape, a plucked lute instrument, is a traditional musical instrument. It is carved in an elongated rectangular shape from the tree trunk, with a homogeneous neck extending from one end of the body. Historically, the three or four strings were made of finely cut rattan, but they are made of wire strings today.", 
      alt: "sape"
  },
]; 

export const UluOthersList = [
  {
      name: "Po'e", 
      img_src: "https://66.media.tumblr.com/cae3bcd8b035c6cb4ebcacee04e7c473/b85f0e3cc7c14366-34/s540x810/5a2dfdfa635c1310ce88311cc53e1da4cc1a5ae0.png",
      description:"Po'e or known as Parang Penan is a  a short, stout straight-edged knife used by the Penan people when they were going through the forest to hunt or making a home. The blade also serves as a weapon. The blade is made of copper whereas the sheath that covers it are made out of wood. ",
      alt: "poe"
  }, 

  {
      name: "Dapur lama",
      img_src:"https://66.media.tumblr.com/c62508dcc9586ffecd51f046f2c6b35f/8111c81f72459d11-37/s540x810/15b21ed232d7e9dcd2e6a73b05829ce198b6e1e9.png", 
      description:"The kitchen is one of the important structures in every room in an Orang Ulu longhouse not only for its typical function as a place to cook but it also serves as a storage for tools and utensils that belongs to the occupants of the room. The kitchen would usually be built-in multi-level with each level would serve as a place to cook, a place for grilling fish or meat, a place to stack firewood,   and a place to store cookware. The picture above is a depiction of the traditional structure of the place to cook.",
      alt: "dapur-lama"
  }, 
]; 